import React from "react";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import Vector from "./VectorMap";
import { Link } from "react-router-dom";

const OnlineLocations = () => {
  return (
    <React.Fragment>
      <Col xl={12}>
        <Card className="card-height-100">
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">Position des agents</h4>
            <div className="flex-shrink-0">
              <Link
                to="/plan"
                type="button"
                className="btn btn-sm text-light"
                style={{ backgroundColor: "#014c94" }}
              >
                Voir plus
              </Link>
            </div>
          </CardHeader>

          <CardBody>
            <div
              data-colors='["--vz-light", "--vz-success", "--vz-primary"]'
              style={{ height: "380px" }}
              dir="ltr"
            >
              <Vector value="world_mill" />
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default OnlineLocations;
